import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 再リース料計算方法 */
enum ReLeaseFeesCalcMethod {
  oneTenth = '1',
  oneTwelfth = '2',
  manualInput = '3',
  unset = '9',
}

const nameConfig = {
  oneTenth: new Map([[Locale.ja, '基本リース料年額の1/10']]),
  oneTwelfth: new Map([[Locale.ja, '基本リース料年額の1/12']]),
  manualInput: new Map([[Locale.ja, '手入力']]),
  unset: new Map([[Locale.ja, '未設定']]),
};

const toEnum = rawValueToEnum(ReLeaseFeesCalcMethod, ReLeaseFeesCalcMethod.unset);
const toDisplay = enumToName(ReLeaseFeesCalcMethod, nameConfig);
const toDisplayWithPrefix = enumToName(ReLeaseFeesCalcMethod, nameConfig, { prefix: true });

export const reLeaseFeesCalcMethod = {
  enum: ReLeaseFeesCalcMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ReLeaseFeesCalcMethod };
